export default "<!-- <pt-header></pt-header> -->\n\n\n<router-outlet></router-outlet>\n\n<!-- <pt-footer></pt-footer> -->"